<div class="flex-fill d-flex flex-column card p-3">
  <div class="d-flex flex-fill flex-column">
    <dx-data-grid #dataGrid keyExpr="id" class="flex-fill d-flex flex-column" [dataSource]="vendors" (onRowDblClick)="rowDoubleClick($event)">
      <dxi-column dataField="id" width="70"></dxi-column>
      <dxi-column dataField="companyName" width="300" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="contactName" width="175" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="address1" width="175"></dxi-column>
      <dxi-column dataField="address2" width="125"></dxi-column>
      <dxi-column dataField="city" width="125"></dxi-column>
      <dxi-column dataField="state" width="100"></dxi-column>
      <dxi-column dataField="zip" width="75"></dxi-column>
      <dxi-column dataField="phone" width="125"></dxi-column>
      <dxi-column dataField="email" width="175"></dxi-column>
      <dxi-column dataField="notes" width="300"></dxi-column>
      <dxi-column dataField="accountNumber" caption="Account #" width="150"></dxi-column>
      <dxi-column dataField="idNumber" caption="Id #" width="100"></dxi-column>
      <dxi-column></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (cell.data) {
          <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
        }
      </div>

      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="vendor-search-grid"></dxo-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success me-2" (click)="open()">Add</button>
        <button
          class="btn btn-sm btn-primary me-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button
          class="btn btn-sm btn-danger me-1"
          (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Delete
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (vendors) {
          <span class="me-3">
            <strong>
              {{ dataGrid.instance.totalCount() + " items" }}
              {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
